import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './AdminiSidebarComponent.css';

function Sidebar() {
  const location = useLocation(); // Get the current route location

  return (
    <div className="admin-sidebar">
      <h2 className="admin-sidebar-title">Admin Dashboard</h2>
      <ul className="admin-sidebar-menu">
        <li>
          <Link
            to="/admin-page/dashboard"
            className={location.pathname === '/admin-page/dashboard' ? 'active' : ''}
          >
            Dashboard
          </Link>
        </li>
        <li>
          <Link
            to="/admin-page/teachers"
            className={location.pathname === '/admin-page/teachers' ? 'active' : ''}
          >
            Teachers
          </Link>
        </li>
        <li>
          <Link
            to="/admin-page/students"
            className={location.pathname === '/admin-page/students' ? 'active' : ''}
          >
            Students
          </Link>
        </li>
        <li>
          <Link
            to="/admin-page/subjects"
            className={location.pathname === '/admin-page/subjects' ? 'active' : ''}
          >
            Subjects
          </Link>
        </li>
        <li>
          <Link
            to="/admin-page/classes"
            className={location.pathname === '/admin-page/classes' ? 'active' : ''}
          >
            Class Approvals
          </Link>
        </li>
        <li>
        <li>
          <Link
            to="/admin-page/published"
            className={location.pathname === '/admin-page/published' ? 'active' : ''}
          >
            Published
          </Link>
        </li>
          <Link
            to="/admin-page/payments"
            className={location.pathname === '/admin-page/payments' ? 'active' : ''}
          >
            Payments
          </Link>
        </li>
        <li>
          <Link
            to="/admin-page/settings"
            className={location.pathname === '/admin-page/settings' ? 'active' : ''}
          >
            Settings
          </Link>
        </li>
      </ul>
    </div>
  );
}

export default Sidebar;